import { MAX_WIDTH, MAX_HEIGHT, JPEG_QUALITY } from "./config.state";
import { getExifSegment, insertExifSegment } from "./exif-utils";

export function resizeAndCompressImage(file, maxW = MAX_WIDTH, maxH = MAX_HEIGHT, quality = JPEG_QUALITY) {
  return new Promise((resolve, reject) => {

    // Step 1: Read the original file to extract EXIF
    const reader = new FileReader();

    reader.onerror = () => reject(new Error("Failed to read file for EXIF extraction"));

    reader.onload = () => {
      let exifSegment = null;

      try {
        exifSegment = getExifSegment(reader.result);
        if (exifSegment) {
          console.log("EXIF segment extracted:", exifSegment.byteLength, "bytes");
        } else {
          console.log("No EXIF segment found in original image");
        }
      } catch (e) {
        console.warn("EXIF extraction failed, continuing without EXIF:", e);
      }

      // Step 2: Compress via Canvas (strips EXIF)
      const url = URL.createObjectURL(file);
      const img = new Image();

      img.onload = () => {
        try {
          let { width, height } = img;
          let targetW = width;
          let targetH = height;

          if (width > maxW || height > maxH) {
            const aspect = width / height;
            if (aspect > 1) {
              targetW = Math.min(width, maxW);
              targetH = Math.round(targetW / aspect);
              if (targetH > maxH) {
                targetH = maxH;
                targetW = Math.round(targetH * aspect);
              }
            } else {
              targetH = Math.min(height, maxH);
              targetW = Math.round(targetH * aspect);
              if (targetW > maxW) {
                targetW = maxW;
                targetH = Math.round(targetW / aspect);
              }
            }
          }

          const canvas = document.createElement("canvas");
          canvas.width = targetW;
          canvas.height = targetH;
          const ctx = canvas.getContext("2d");
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = "high";
          ctx.drawImage(img, 0, 0, targetW, targetH);

          canvas.toBlob(
            async (blob) => {
              URL.revokeObjectURL(url);
              if (!blob) return reject(new Error("Compression failed — toBlob returned null"));

              // Step 3: Re-insert EXIF if available
              if (exifSegment) {
                try {
                  const blobWithExif = await insertExifSegment(blob, exifSegment);
                  console.log("EXIF re-inserted into compressed image");
                  resolve(blobWithExif);
                } catch (e) {
                  console.warn("Failed to insert EXIF, returning without EXIF:", e);
                  resolve(blob);
                }
              } else {
                resolve(blob);
              }
            },
            "image/jpeg",
            quality
          );
        } catch (err) {
          URL.revokeObjectURL(url);
          reject(err);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("Failed to load image for compression"));
      };

      img.src = url;
    };

    // Read only the first 64KB where EXIF APP1 segments live
    const headerChunk = file.slice(0, 64 * 1024);
    reader.readAsArrayBuffer(headerChunk);
  });
}
